export function tenantInfo() {
  let tenantInfo = localStorage.getItem('tenantInfo') ? JSON.parse(localStorage.getItem('tenantInfo')) : null;
  const tenantPermission = localStorage.getItem('tenant_permission')
    ? JSON.parse(localStorage.getItem('tenant_permission'))
    : null;
  if (tenantPermission && tenantPermission.length > 0) {
    tenantInfo = (tenantInfo || []).filter((t) => tenantPermission.includes(t.id));
  }
  return tenantInfo;
}

export function getTenantPermission() {
  return localStorage.getItem('tenant_permission') ? JSON.parse(localStorage.getItem('tenant_permission')) : null;
}
